import { NamedComplexEnum } from '../../../utils/complexEnum/NamedComplexEnum'
import { Multiple, Single, Checkboxes } from './instances'

type CustomListItemStyleItem =
  | typeof Multiple
  | typeof Single
  | typeof Checkboxes
type Name = CustomListItemStyleItem['name']
type ID = CustomListItemStyleItem['id']

class CustomListItemStyleEnum extends NamedComplexEnum<
  'CustomListItemStyle',
  CustomListItemStyleItem,
  Name,
  ID
> {
  readonly typename = 'CustomListItemStyle'
  get values() {
    return [this.Multiple, this.Single, this.Checkboxes]
  }
  Multiple = Multiple
  Single = Single
  Checkboxes = Checkboxes
}

export const CustomListItemStyle = new CustomListItemStyleEnum()
